import {OptionsObject, useSnackbar, VariantType} from "notistack";
import {useCallback} from "react";

export function useToast() {
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    const showToast = useCallback(
        (message?: string | null, variant: VariantType = "success", key?: string) => {
            if (!message) return;
            let options: OptionsObject = {
                variant,
                key: key || new Date().getTime() + Math.random(),
                preventDuplicate: true
            };
            if (variant === "success") {
                options = {
                    ...options,
                    autoHideDuration: 2000,
                    disableWindowBlurListener: true,
                };
            } else if (variant === "warning") {
                options = {
                    ...options,
                    autoHideDuration: 5000,
                    disableWindowBlurListener: true,
                };
            } else if (variant === "error") {
                options = {
                    ...options,
                    autoHideDuration: 12000,
                }
            }
            message && enqueueSnackbar(message, options);
            return options.key;
        }, [enqueueSnackbar]
    );

    const hideToast = useCallback((key?: string | number) => {
        if (key) {
            closeSnackbar(key);
        }
    }, [closeSnackbar]);

    return {showToast, hideToast};
}